export const Faqs = () => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.34783 12.9322H11.4638L15.6377 16.8373C15.7826 16.9458 15.9275 17 16.0725 17C16.1594 17 16.2174 17 16.3043 16.9458C16.5072
        16.8644 16.6522 16.6746 16.6522 16.4576V12.9322H18.6522C19.9565 12.9322 21 11.9559 21 10.7356V3.19661C21 1.97627 19.9565 1 18.6522
        1H3.34783C2.04348 1 1 1.97627 1 3.19661V10.7356C1 11.9559 2.04348 12.9322 3.34783 12.9322ZM2.15942 3.19661C2.15942 2.57288 2.71014
        2.08475 3.34783 2.08475H18.6522C19.3188 2.08475 19.8406 2.6 19.8406 3.19661V10.7356C19.8406 11.3593 19.2899 11.8475 18.6522
        11.8475H16.0725C15.7536 11.8475 15.4928 12.0915 15.4928 12.3898V15.1559L12.1304 12.0102C12.0145 11.9017 11.8696 11.8475 11.7246
        11.8475H3.34783C2.68116 11.8475 2.15942 11.3322 2.15942 10.7356V3.19661Z"
        fill="#0374D6"
        stroke="#0374D6"
        strokeWidth="0.4"
      />
      <path
        d="M10.6642 8C10.6642 7.69874 10.7312 7.45049 10.8651 7.25523C11.0045 7.05439 11.2054 6.83682 11.4676 6.60251C11.6684 6.42399
        11.8163 6.27057 11.9111 6.14226C12.0115 6.00837 12.0617 5.85774 12.0617 5.69038C12.0617 5.45607 11.9669 5.26639 11.7772 5.12134C11.5875
        4.97629 11.3337 4.90377 11.0157 4.90377C10.4132 4.90377 9.95852 5.11855 9.65168 5.54812L8.83997 5.02092C9.07985 4.69177 9.38948 4.44073
        9.76884 4.26778C10.1482 4.08926 10.5945 4 11.1077 4C11.7326 4 12.2291 4.13668 12.5973 4.41004C12.9711 4.67782 13.158 5.04881 13.158
        5.52301C13.158 5.75174 13.1189 5.95258 13.0408 6.12552C12.9683 6.29847 12.879 6.4463 12.773 6.56904C12.667 6.68619 12.5276 6.82287
        12.3546 6.97908C12.1426 7.16876 11.9836 7.33612 11.8776 7.48117C11.7772 7.62622 11.727 7.79916 11.727 8H10.6642ZM11.1998 10C11.0045
        10 10.8428 9.93863 10.7144 9.8159C10.5917 9.68759 10.5303 9.53138 10.5303 9.34728C10.5303 9.16318 10.5917 9.00976 10.7144 8.88703C10.8428
        8.7643 11.0045 8.70293 11.1998 8.70293C11.3895 8.70293 11.5457 8.7643 11.6684 8.88703C11.7967 9.00976 11.8609 9.16318 11.8609 9.34728C11.8609
        9.53138 11.7967 9.68759 11.6684 9.8159C11.5457 9.93863 11.3895 10 11.1998 10Z"
        fill="#0374D6"
        stroke="#0374D6"
        strokeWidth="0.4"
      />
    </svg>
  )
}
